import {useCallback, type ComponentProps} from 'react';
import {useNode} from '@craftjs/core';
import {useEditorStyle} from 'hooks';
import {classNames} from 'utils';

import EditorInspectorContainer from './Editor.Inspector.Container';

interface IEditorContentContainerProps extends ComponentProps<'div'> {
  mobileStyle?: React.CSSProperties;
}

const EditorContentContainer = ({mobileStyle, ...props}: IEditorContentContainerProps) => {
  const {
    connectors: {connect, drag},
    selected,
    hovered,
  } = useNode(node => ({
    selected: node.events.selected,
    hovered: node.events.hovered,
  }));

  const ref = useCallback((node: HTMLDivElement) => {
    node && connect(drag(node));
  }, []);

  const {style} = useEditorStyle();

  return (
    <div
      {...props}
      ref={ref}
      className={classNames(hovered ? 'shadow-[inset_0_0_0_2px_#34bb78]' : selected ? 'shadow-[inset_0_0_0_2px_#acbdd4]' : '')}
      style={style}></div>
  );
};

EditorContentContainer.craft = {
  displayName: 'Container',
  custom: {
    icon: 'Squares2X2Icon',
  },
  props: {
    mobileStyle: {},
  },
  related: {
    settings: EditorInspectorContainer,
  },
};

export default EditorContentContainer;
